import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    input,
    output,
    ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlooriIconComponent } from '../floori-icon/floori-icon.component';
import { FlooriButtonComponent } from '../floori-button/floori-button.component';
import { FlooriDialogModule } from '../floori-dialog/floori-dialog.module';
import { TooltipDirective } from '../../directives/tooltip/tooltip.directive';
import { TranslationsModule } from '../../modules';
import { ActionContainerButtonData } from '../../models';

@Component({
    selector: 'floori-action-container-header',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [
        CommonModule,
        FlooriIconComponent,
        FlooriButtonComponent,
        FlooriDialogModule,
        TranslationsModule,
        TooltipDirective,
    ],
    providers: [],
    templateUrl: './action-container-header.component.html',
    styleUrls: ['./action-container-header.component.scss']
})
export class ActionContainerHeaderComponent {
    readonly headerType = input.required<string>();
    readonly showCloseButton = input<boolean>(false);
    readonly primaryButton = input<ActionContainerButtonData>();
    readonly secondaryButton = input<ActionContainerButtonData>();
    readonly tertiaryButton = input<ActionContainerButtonData>();
    readonly showSelector = input<boolean>(false);
    readonly selectorValue = input<string>('');
    readonly title = input<string>('');
    readonly icon = input<string>('');
    readonly message = input<string>('');
    readonly isMobile = input<boolean>(false);
    readonly isMobileBySize = input<boolean>(false);

    readonly closeClick = output<void>();
    readonly primaryButtonClick = output<void>();
    readonly secondaryButtonClick = output<void>();
    readonly tertiaryButtonClick = output<void>();
    readonly selectorClick = output<void>();

    @HostBinding('class.floori-action-container-header') hostClass = true;

    selectorClickHandler(): void {
        this.selectorClick.emit();
    }

    closeHandler(): void {
        this.closeClick.emit();
    }

    primaryButtonClickHandler(): void {
        this.primaryButtonClick.emit();
    }

    secondaryButtonClickHandler(): void {
        this.secondaryButtonClick.emit();
    }

    tertiaryButtonClickHandler(): void {
        this.tertiaryButtonClick.emit();
    }
}
